import React, {useEffect, useState} from 'react';
import CustomTh from '../../../../../components/table/CustomTh';
import CustomTd from '../../../../../components/table/CustomTd';
import DropDownMenuProfile from '../../../../../components/DropDown/DropDownMenuProfile';
import DropDownMenuItem from '../../../../../components/DropDown/DropDownMenuItem';
import {DetailsIconsOptions, QrCodeIcon} from '../../../../../components/buttons/IconButtons';
import TableFunction from '../../../../../components/table/TableFunction';
import CustomChip from '../../../../../components/CustomChip';
import { colors } from '../../../../../enums/colors';
import {status} from "../../../../../enums/statusEnum";
import {DATE_TIME_FORMAT_NAME_MODEL, EMPTY_VALUES, getDateFormat} from '../../../../../Apis/functions';
import {statusBorderColor, statusColor, statusFontColor} from "../../../../../enums/statusColorEnum";
import {useDispatch, useSelector} from "react-redux";
import {
    GetExtraOrders, GetStatusByUserIdActive,
} from "../../../../../reduxToolkit/FoodieExtraMeal/FoodieExtraMealApi";
import {renderMeals, REQUEST_STATUS} from "../Model/Models";
import { FOODIE_REQUEST } from './../../Request/Model/Model';

/**
 * @Author: Susana García Rodríguez
 * @JobTitle : Frontend
 * @Email : sgarcia@ibl.mx
 *
 */
const HistoryTableApp = ({
    modified,
    setModified,
    setItemSelected,
    searchElement,
    setShowSummaryModal,
    handleDownload,
    option,
    setBodyForExport
}) => {
    const dispatch = useDispatch();
    const tableId = 'tbl_ht_history';
    const searchId = 'txt_ht_search_history';
    const  statusDb  = useSelector((state) => state.FoodieExtraMealSlice.statusByUserIdActive);
    const [results, setResults] = useState(null);
    const { user } = useSelector((state) => state.authenticatioauthennSlice);
    const userId = user?.data?.id;

    useEffect(() => {
        getStatuses();
    }, []);

    const getStatuses = () => {
        dispatch(GetStatusByUserIdActive({userId,  isHistory: true }));
    }

    const getThead = () => {
        return [
            <CustomTh tableId={tableId} classes='first_head'>
                {t('serving_date')}
            </CustomTh>,
            <CustomTh tableId={tableId}>{t('diner')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('request_date')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('meal_time')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('menu_items')}</CustomTh>,
            <CustomTh tableId={tableId}>{t('status')}</CustomTh>,
        ];
    };
    const getTbody = () => {
       if (!results || results?.content?.length === 0)
            return {
                body: [],
                data: [],
            };

        let body = results?.content.map((item) => {
            return (
                <>
                    <CustomTd classes={'first-column'} tableId={tableId}>
                        {item?.servingDate
                            ? getDateFormat(item.servingDate, false,  DATE_TIME_FORMAT_NAME_MODEL.shortMonth)
                            : EMPTY_VALUES.DEFAULT}
                    </CustomTd>
                    <CustomTd tableId={tableId}>{item?.cafeteriaName || EMPTY_VALUES.DEFAULT}</CustomTd>
                    <CustomTd tableId={tableId}>
                        {item?.createdAt ? getDateFormat(item.createdAt, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth) : EMPTY_VALUES.DEFAULT}
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        {item?.mealTimeName ? (
                            <CustomChip
                                background={colors.secondary100}
                                fontColor={colors.secondary700}
                                borderColor={colors.secondary150}
                                legend={item?.mealTimeName}
                            />
                        ) : (
                            EMPTY_VALUES.DEFAULT
                        )}
                    </CustomTd>
                    <CustomTd tableId={tableId}>
                        {renderMeals(item)}
                    </CustomTd>

                    <CustomTd tableId={tableId}>
                        <CustomChip
                            background={statusColor[item?.approvalStatusId]}
                            fontColor={statusFontColor[item?.approvalStatusId]}
                            borderColor={statusBorderColor[item?.approvalStatusId]}
                            legend={t(status[item?.approvalStatusId]) || EMPTY_VALUES.DEFAULT}
                            variant='large'
                        />
                    </CustomTd>
                </>
            );
        });

        return {
            body: body,
            data: results?.content,
        };
    };

    const getActionsButtons = (item, index) => {
        if (!item) return null;
        return (
            <>
                {(item?.approvalStatusId === REQUEST_STATUS.APPROVED.id || item?.approvalStatusId === REQUEST_STATUS.DENIED.id) ? (
                    <DropDownMenuProfile
                        openMenu={openMenu}
                        handleMenuToggle={handleMenuToggle}
                        menuId={`menu-${item?.id}`}
                    >
                        <DropDownMenuItem
                            index={index}
                            handleClose={handleClose}
                            name={t('details')}
                            icon={<DetailsIconsOptions />}
                            click={() => {
                                setShowSummaryModal(true);
                                setItemSelected(item);
                            }}
                        />
                        {(item?.approvalStatusId === REQUEST_STATUS.APPROVED.id && item?.id) && (
                            <DropDownMenuItem
                                index={index}
                                handleClose={handleClose}
                                name={t('QR')}
                                icon={<QrCodeIcon />}
                                click={() => handleDownload(item?.id)}
                            />
                        )}
                    </DropDownMenuProfile>
                ) : (
                    <>{EMPTY_VALUES.DEFAULT}</>
                )}
            </>
        );
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page, { searchElement }) => {
        const body = {
            key: searchElement,
            searchType:FOODIE_REQUEST.USER_HISTORY,
            pagination: {
                page,
                size: rowsPerPage
            }
        };
        setBodyForExport({
            ...body,
            model: option,
            userId: userId
        });
        dispatch(GetExtraOrders(body)).then(({ payload:{ data: { data, success }} }) => {
            if (success) {
                setResults(data.value);
            }
        });
        getStatuses();
    }

    const {
        t,
        thead,
        tbody,
        openMenu,
        handleMenuToggle,
        handleClose,
        pagination,
        handleCheckboxChange,
        page,
        rowsPerPage,
    } = TableFunction({
        data:results,
        labelRowsPerPage: 'request_per_page',
        getTbody,
        getThead,
        fixedPagination: false,
        hasContainer: true,

        searchElement, //New
        getData,//New
        modified,//New
        setModified//New
    });

    return {
        option,
        t,
        tableId,
        searchId,
        tbody,
        thead,
        status:statusDb,
        results,
        setResults,
        getActionsButtons,
        handleCheckboxChange,
        pagination,
        setBodyForExport,
        page,
        rowsPerPage,
        getData
    };
};
export default HistoryTableApp;
